import config from '../../../_config/global';
import {
  IDeleteSingleArgs,
  IGetSingleArgs,
  IPageAndSearchArgs,
  IUpdateSingleArgs
} from '../../../interfaces';
import { goFetch } from '../../../utilities/goFetch';
import {
  Banks,
  CardsItemProps,
  Network,
  SpendingCategory
} from '../components';
import { ExportToCsv } from 'export-to-csv';

interface apiResponse {
  data: Object;
  message?: string;
  success: boolean;
}
class Service {
  async getByPage({ search, pageNo }: IPageAndSearchArgs) {
    const cards = (await goFetch(config.endpoints.cards.getByPage)
      .withQueryParameters({
        search: search ?? '',
        pageSize: config.pageSize,
        pageNumber: pageNo || 1
      })
      .get()) as any;

    let { paginatedResults, totalCount } = cards?.data[0] || {};
    const itemCount = totalCount?.[0]?.count || 0;

    return {
      pageNo: pageNo,
      pageSize: config.pageSize,
      pageCount: Math.ceil(itemCount / config.pageSize),
      data: paginatedResults,
      itemCount
    };
  }

  async getAllSpendCate(): Promise<SpendingCategory[]> {
    const spend = (await goFetch(
      config.endpoints.cards.allSpendCate
    ).get()) as any;
    return spend;
  }

  async getAllBanks(): Promise<Banks[]> {
    const banks = (await goFetch(config.endpoints.cards.allBanks).get()) as any;
    return banks;
  }

  async getAllNetworks(): Promise<Network[]> {
    const networks = (await goFetch(
      config.endpoints.cards.allNetworks
    ).get()) as any;
    return networks.data;
  }

  async getSingle({ key }: IGetSingleArgs) {
    if (key !== '') {
      const award = (await goFetch(`${config.endpoints.cards.getSingle}`)
        .withQueryParameters({ id: key })
        .get()) as unknown as apiResponse;

      return award.data;
    }
  }

  async create(id: string) {
    let newCard: CardsItemProps = {
      data: {
        _id: id,
        name: id,
        signupBonus: 0,
        cashBonus: 0,
        minimumSpend: 0,
        daysToSpend: 0,
        annual_fee: 0,
        cashPerks: 0,
        cardFamily: 0,
        rewards_currency: '',
        bank: {
          name: ''
        },
        network: {
          name: ''
        },
        websiteUrl: '',
        chargeCard: false,
        annualFeeWaived: false,
        bisCard: false,
        colour: ''
      }
    };
    const res = await goFetch(`${config.endpoints.cards.add}`)
      .withBody(newCard)
      .put();
    return res as unknown as apiResponse;
  }

  async export() {
    var cards = (await goFetch(config.endpoints.cards.getByPage)
      .withQueryParameters({
        search: '',
        pageSize: 1,
        pageNumber: 1
      })
      .get()) as any;
    var { paginatedResults, totalCount } = cards?.data[0] || {};
    var itemCount = totalCount?.[0]?.count || 0;

    var cards = (await goFetch(config.endpoints.cards.getByPage)
      .withQueryParameters({
        search: '',
        pageSize: itemCount,
        pageNumber: 1
      })
      .get()) as any;
    var { paginatedResults, totalCount } = cards?.data[0] || {};

    const options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: true,
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: true
    };

    const csvExporter = new ExportToCsv(options);

    csvExporter.generateCsv(paginatedResults);
  }

  async update({ key, ...rest }: IUpdateSingleArgs) {
    return goFetch(`${config.endpoints.cards.update}`)
      .withBody({
        _id: key,
        ...rest
      })
      .post() as unknown as apiResponse;
  }

  async updateSpendingCategories(key: string, spendingCategories: any[]) {
    return goFetch(`${config.endpoints.cards.updateSpendingCategories}`)
      .withBody({
        _id: key,
        spendingCategories: spendingCategories
      })
      .post() as unknown as apiResponse;
  }

  async delete(key: IDeleteSingleArgs) {
    await goFetch(`${config.endpoints.cards.delete}`)
      .withBody({ _id: key })
      .delete();
  }
}

export default new Service();
